export enum Route {
  Home,
  Question,
  Results,
}
